

import React, { useContext, useEffect, useState } from 'react'
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
import { getEntreprisesMini } from '../../context/entrepriseContext/apiCalls';
import { EntrepriseContext } from '../../context/entrepriseContext/EntrepriseContext';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import FilterMonthInput from '../../components/filterMonthInput/FilterMonthInput';
import { InvoiceContext } from '../../context/invoiceContext/InvoiceContext';
import { useNavigate, useParams } from 'react-router-dom';
import { createInvoice, loadInvoice } from '../../context/invoiceContext/apiCalls';
import TableComponent from '../../components/tableComponent/TableComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { currentStatusEnvois, typeEnvois, wilayas, withTVAs } from '../../data';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import FormRadio from '../../components/formRadio/FormRadio';

function CreateInvoice() {
    const { dispatch, isFetchingAdd, errorAdd, invoice, isFetchingEnvoisRamassageDepot, errorEnvoisRamassageDepot, envois, allEnvois, historiesRamassage, historiesDepot, count: pages, countGlobal, sumCost, sumMontant} = useContext(InvoiceContext);
    const { dispatch: dispatchEntreprise, entreprisesMini } = useContext(EntrepriseContext);

    const [addEntreprise, setAddEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });
    const [addDateApplyInvoice, setAddDateApplyInvoice] = useState("");
    const [withTVA, setWithTVA] = useState(withTVAs[0])
    const [addErrorBox, setAddErrorBox] = useState("");

    const [historiesRamassageAlt, setHistoriesRamassageAlt] = useState([]);
    const [historiesDepotAlt, setHistoriesDepotAlt] = useState([])

    const [totalRamassage, setTotalRamassage] = useState(0);
    const [totalDepot, setTotalDepot] = useState(0);

    const navigate = useNavigate();
    const { page = 1 } = useParams();
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        getEntreprisesMini(dispatchEntreprise);
    }, [])
    useEffect(() => {
        if (Object.keys(invoice).length !== 0) {
            dispatch({
                type: "CLEAR_INVOICE",
            })
            navigate(`/invoices/1`);
        }
    }, [invoice])

    useEffect(() => {
        if (errorAdd != false) {
            setAddErrorBox(errorAdd);
        }
        if (errorEnvoisRamassageDepot != false) {
            setAddErrorBox(errorEnvoisRamassageDepot);
        }
    }, [errorAdd, errorEnvoisRamassageDepot])

    useEffect(() => {
        if (addEntreprise.id !== 0 && addDateApplyInvoice !== '') {
            setAddErrorBox('');
            loadInvoice(dispatch, page, pageSize, addEntreprise.id, addDateApplyInvoice);
        } else {
            dispatch({
                type: "CLEAR_INVOICE",
            })
        }
    }, [page, pageSize, addEntreprise, addDateApplyInvoice])

    useEffect(() => {
        setTotalRamassage(0);
        setTotalDepot(0);
        setHistoriesRamassageAlt([]);
        setHistoriesDepotAlt([]);

        if (!isFetchingEnvoisRamassageDepot) {

            // to eliminate duplicate ActionId in Ramassage
            var actionIdRamassage = 0;
            if (historiesRamassage.length !== 0) {
                historiesRamassage.map(item => {
                    if (item.ActionId !== actionIdRamassage) {
                        actionIdRamassage = item.ActionId;
                        setTotalRamassage(prev => prev + (item.cost * 1));
                        setHistoriesRamassageAlt(prev => [...prev, item]);
                    }
                });
            }

            // to eliminate duplicate ActionId in Depot
            var actionIdDepot = 0;
            if (historiesDepot.length !== 0) {
                historiesDepot.map(item => {
                    if (item.ActionId !== actionIdDepot) {
                        actionIdDepot = item.ActionId;
                        setTotalDepot(prev => prev + (item.cost * 1));
                        setHistoriesDepotAlt(prev => [...prev, item]);
                    }
                });
            }

        }
    }, [envois, historiesRamassage, historiesDepot])

    const createInvoiceHandler = () => {
        if (addEntreprise.id !== 0 && addDateApplyInvoice !== '') {
            var total = sumCost * 1 + totalRamassage * 1 + totalDepot * 1;
            if (withTVA.id === 1) {
                total = sumMontant - total * 1.19
            } else {
                total = sumMontant - total
            }
            createInvoice(dispatch, total, sumCost, sumMontant, totalRamassage, totalDepot, addEntreprise.id, addDateApplyInvoice, allEnvois, historiesRamassage, historiesDepot, withTVA.id);
        }
    }


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="invoice" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Créer une Facture :</span>
                </div>

                <div className="content invoice">
                    <div className="box">
                        <div className="box-content">
                            {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                            <DropDownComponent data={[{ nom: "Choisir Entreprise", id: 0 }, ...entreprisesMini]} itemChoisir={addEntreprise} setItemChoisir={setAddEntreprise} filter />
                            <FilterMonthInput placeholder={"Date Application"} item={addDateApplyInvoice} setItem={setAddDateApplyInvoice} />
                        </div>
                    </div>

                    {
                        isFetchingEnvoisRamassageDepot ? <LoadingComponent /> : (
                            <>
                                {
                                    envois.length !== 0 && (
                                        <div className='part'>
                                            <span className='sub-title'>Frais Total</span>
                                            <TableComponent isHeaderExist={false} maxWidth={400} headers={['Id', 'Frais',]}>
                                                <>
                                                    <tr>
                                                        <td>Nombre d'Envois</td>
                                                        <td>{countGlobal}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Montant</td>
                                                        <td>{Number.parseFloat(sumMontant).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Frais Envois</td>
                                                        <td>{Number.parseFloat(sumCost).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Frais Ramassage</td>
                                                        <td>{Number.parseFloat(totalRamassage).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Frais Dépot</td>
                                                        <td>{Number.parseFloat(totalDepot).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total H.T</td>
                                                        <td>{Number.parseFloat(sumCost * 1 + totalRamassage * 1 + totalDepot * 1).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ width: "100%" }}><FormRadio data={withTVAs} itemChoisir={withTVA} setItemChoisir={setWithTVA} name='tab-with-without-tva' /></td>
                                                        <td></td>
                                                    </tr>
                                                    {
                                                        withTVA.id === 1 ? (
                                                            <>
                                                                <tr>
                                                                    <td>TVA (19%)</td>
                                                                    <td>{Number.parseFloat((sumCost * 1 + totalRamassage * 1 + totalDepot * 1) * 0.19).toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total TTC</td>
                                                                    <td>{Number.parseFloat(sumMontant - (sumCost * 1 + totalRamassage * 1 + totalDepot * 1) * 1.19).toFixed(2)}</td>
                                                                </tr>
                                                            </>
                                                        ) : (
                                                                <tr>
                                                                    <td>Total</td>
                                                                    <td>{Number.parseFloat(sumMontant - (sumCost * 1 + totalRamassage * 1 + totalDepot * 1)).toFixed(2)}</td>
                                                                </tr>
                                                        )
                                                    }
                                                </>
                                            </TableComponent>
                                        </div>
                                    )
                                }
                                {
                                    envois.length === 0 ? <span className='no-data' style={{ margin: "150px auto" }}>Il n'y a pas encore de données</span> : (
                                        <div className='part'>
                                            <span className='sub-title'>Frais des Livraisons</span>
                                            <TableComponent headers={withTVA.id === 1
                                                ? ["Date d'expédition", "Envoi N°", "Type", "Destinataire", "Destination", "Pois", "Montant", "Frais", "TVA(19%)", "Rest"]
                                                : ["Date d'expédition", "Envoi N°", "Type", "Destinataire", "Destination", "Pois", "Montant", "Frais", "Rest"]}>
                                                {
                                                    envois.map((ele, index) => (
                                                        <tr key={index}>
                                                            <td>{ele.createdAt.slice(0, 10)}</td>
                                                            <td>{`${currentStatusEnvois.filter(item => item.id === ele.currentStatus)[0]['nom']}-${ele.tracking}`}</td>
                                                            <td>{typeEnvois.filter(item => item.id === ele.typeEnvoie)[0]['nom']} </td>
                                                            <td>{ele.nomArrived}</td>
                                                            <td>{wilayas.filter(item => item.id === ele.wilayaArrived)[0]['nom']} </td>
                                                            <td>{ele.weight}</td>
                                                            <td>{Number.parseFloat(ele.montant).toFixed(2)} </td>
                                                            <td>{Number.parseFloat(ele.cost).toFixed(2)} </td>
                                                            {
                                                                withTVA.id === 1 ? (
                                                                    <>
                                                                        <td>{Number.parseFloat(ele.cost * 0.19).toFixed(2)} </td>
                                                                        <td>{Number.parseFloat(ele.montant * 1 - ele.cost * 1.19).toFixed(2)} </td>
                                                                    </>
                                                                ) : (
                                                                    <td>{Number.parseFloat(ele.montant * 1 - ele.cost * 1).toFixed(2)} </td>
                                                                )
                                                            }
                                                        </tr>
                                                    ))
                                                }
                                            </TableComponent>
                                            {
                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item={`invoices/create`} />)
                                            }
                                        </div>
                                    )
                                }
                                {
                                    historiesRamassageAlt.length !== 0 && (
                                        <div className='part'>
                                            <span className='sub-title'>Coût de Ramassage</span>
                                            <TableComponent maxWidth={300} headers={['Date', 'Frais']}>
                                                {
                                                    historiesRamassageAlt.map((ele, index) => (
                                                        <tr key={index}>
                                                            <td>{ele.createdAt.slice(0, 10)}</td>
                                                            <td>{ele.cost}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </TableComponent>
                                        </div>
                                    )
                                }
                                {
                                    historiesDepotAlt.length !== 0 && (
                                        <div className='part'>
                                            <span className='sub-title'>Coût de Dépot Domicile</span>
                                            <TableComponent maxWidth={300} headers={['Id', 'Frais']}>
                                                {
                                                    historiesDepotAlt.map((ele, index) => (
                                                        <tr key={index}>
                                                            <td>{ele.createdAt.slice(0, 10)}</td>
                                                            <td>{ele.cost}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </TableComponent>
                                        </div>
                                    )
                                }
                                <div className="add-item" style={{ justifyContent: 'center', marginTop: '30px' }}>
                                    {
                                        envois.length !== 0 && (
                                            <span className='color-1' onClick={createInvoiceHandler} style={isFetchingAdd ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                {
                                                    isFetchingAdd ? "Créer une Facture ..." : "Créer une Facture"
                                                }
                                            </span>
                                        )
                                    }
                                </div>
                            </>
                        )
                    }

                </div>
            </div>

        </div>
    )
}

export default CreateInvoice
